<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <!-- Filtros -->
          <div class="row pl-4 pr-4" v-show="tela === 1">
            <h4 class="card-title text-left m-0">
              PAINEL DE ESCALAS
            </h4>

            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              tipo="basico"
              :btEnviarEmail="false"
              @pesquisar="pesquisar"
            />

            <div class="offset-sm-6"></div>
          </div>

          <!-- Resultados -->
          <div class="row pl-4 pr-4" v-show="tela === 2">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                >
                  <i class="tim-icons icon-minimal-left"></i>
                  Voltar
                </base-button>
              </div>

              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  :disabled="isLoading || !dados.dados.length"
                  simple
                  @click="imprimirFolha"
                >
                  <i class="tim-icons icon-paper"></i>
                  Imprimir
                </base-button>
              </div>
            </div>

            <!-- Cabeçalho -->
            <div
              class="container p-3 rounded"
              style="background: #f9f9f9;"
              v-show="!printing"
            >
              <div class="row">
                <div class="col-12 text-left">
                  <div>PAINEL DE ESCALAS</div>

                  <div>
                    PERÍODO:
                    {{
                      moment(payloadPesquisa.data_inicial).format("DD/MM/YYYY")
                    }}
                    à
                    {{
                      moment(payloadPesquisa.data_final).format("DD/MM/YYYY")
                    }}
                  </div>

                  <div v-if="!payloadPesquisa.id_funcionario">
                    DEPARTAMENTO:
                    {{
                      payloadPesquisa.departamento
                        ? payloadPesquisa.departamento.descricao
                        : "TODOS"
                    }}
                  </div>
                  <div v-else>
                    DEPARTAMENTO: NENHUM
                  </div>

                  <div v-if="!payloadPesquisa.id_funcionario">
                    POSTO DE TRABALHO:
                    {{
                      payloadPesquisa.posto
                        ? payloadPesquisa.posto.local
                        : "TODOS"
                    }}
                  </div>
                  <div v-else>
                    POSTO DE TRABALHO: NENHUM
                  </div>
                </div>
              </div>
            </div>

            <!-- Quantidade por página -->
            <div class="col-12 pt-3 hidden-print" v-show="!printing">
              <el-select
                v-model="pagination.perPage"
                class="select-success pagination-select"
                style="width: 170px;"
                placeholder="Por página"
                :disabled="isLoading"
                @change="alterarQuantidadePorPagina"
              >
                <el-option
                  v-for="quantidade in perPageOptions"
                  :key="quantidade"
                  class="select-success"
                  :label="quantidade + ' por página'"
                  :value="quantidade"
                />
              </el-select>
            </div>

            <!-- Tabela -->
            <div class="col-12 table-responsive p-3">
              <div id="imprimirFolha">
                <table class="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Nome</th>

                      <th
                        v-for="(dia, indiceDia) in dados.dias"
                        :key="indiceDia"
                        scope="col"
                      >
                        {{ dia }}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(funcionario, indiceFuncionario) in dados.dados"
                      :key="indiceFuncionario"
                    >
                      <td
                        v-for="(valor, indiceColuna) in funcionario"
                        :key="indiceColuna"
                        :class="classeCelula(valor)"
                      >
                        <p class="m-0 p-0">
                          {{
                            typeof valor === "string"
                              ? valor
                              : valor === true
                              ? "Folga"
                              : ""
                          }}
                        </p>
                      </td>
                    </tr>

                    <tr v-if="!dados.dados.length">
                      <td :colspan="dados.dias.length + 1" class="text-center">
                        Nenhum resultado encontrado.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Paginação -->
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap hidden-print"
              v-show="!printing"
            >
              <p class="font-weight-normal">
                Mostrando de {{ from }} a {{ to }} no total de
                {{ pagination.totalItems }} funcionários.
              </p>

              <base-pagination
                v-if="pagination.totalItems > 0"
                class="pagination-no-border"
                :value="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.totalItems"
                @input="listarEscalas"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      />
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { Card, BasePagination, BaseFiltroRelatorio } from "@/components/index";

import { Select, Option } from "element-ui";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    BasePagination,
    BaseFiltroRelatorio,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      payloadPesquisa: {},
      printing: false,
      isLoading: false,
      tela: 1,

      dados: {
        dias: [],
        dados: [],
      },

      perPageOptions: [10, 50, 100],

      pagination: {
        currentPage: 1,
        perPage: 100,
        totalItems: 0,
        totalPages: 0,
      },

      // Impede uma resposta antiga de substituir a pesquisa mais recente.
      requisicaoAtual: 0,
    };
  },

  computed: {
    from() {
      if (!this.dados.dados.length) {
        return 0;
      }

      return this.pagination.perPage * (this.pagination.currentPage - 1) + 1;
    },

    to() {
      if (!this.dados.dados.length) {
        return 0;
      }

      return Math.min(
        this.from + this.dados.dados.length - 1,
        this.pagination.totalItems,
      );
    },
  },

  beforeDestroy() {
    this.requisicaoAtual += 1;
  },

  methods: {
    moment(data) {
      return moment(data);
    },

    classeCelula(valor) {
      if (typeof valor === "string") {
        return "";
      }

      return valor === true ? "tb-folgas" : "bg-secondary";
    },

    pesquisar(filtros) {
      this.payloadPesquisa = { ...filtros };

      return this.listarEscalas(1);
    },

    alterarQuantidadePorPagina() {
      return this.listarEscalas(1);
    },

    async listarEscalas(page = 1) {
      const requisicao = ++this.requisicaoAtual;

      this.isLoading = true;

      const usuario = this.$cookies.get("usuario");

      const payload = {
        ...this.payloadPesquisa,
        setDB: this.$cookies.get("db"),
        idUsuario: usuario ? usuario.id : "",
        page,
        limit: this.pagination.perPage,
      };

      try {
        const response = await this.axios.post(
          "/api/relatorio/painelEscala",
          payload,
        );

        if (requisicao !== this.requisicaoAtual) {
          return;
        }

        const resultado = response.data.data;

        // Estrutura esperada:
        // resultado.dados.dias
        // resultado.dados.dados
        // resultado.pagination
        if (
          !resultado ||
          !resultado.dados ||
          !Array.isArray(resultado.dados.dias) ||
          !Array.isArray(resultado.dados.dados) ||
          !resultado.pagination
        ) {
          throw new Error("Formato de resposta do painel de escalas inválido.");
        }

        this.dados = {
          dias: resultado.dados.dias,
          dados: resultado.dados.dados,
        };

        // Atualiza a paginação mesmo quando a pesquisa está vazia.
        this.pagination = {
          currentPage: Number(resultado.pagination.currentPage) || page,
          perPage:
            Number(resultado.pagination.perPage) || this.pagination.perPage,
          totalItems: Number(resultado.pagination.totalItems) || 0,
          totalPages: Number(resultado.pagination.totalPages) || 0,
        };

        this.tela = 2;
      } catch (error) {
        if (requisicao !== this.requisicaoAtual) {
          return;
        }

        console.error("Erro ao carregar painel de escalas:", error);

        // Evita mostrar resultados anteriores após uma falha.
        this.dados = {
          dias: [],
          dados: [],
        };

        this.pagination.totalItems = 0;
        this.pagination.totalPages = 0;

        window.alert("Não foi possível carregar o painel de escalas.");
      } finally {
        if (requisicao === this.requisicaoAtual) {
          this.isLoading = false;
        }
      }
    },

    async imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        await this.$nextTick();

        this.$htmlToPaper("imprimirFolha", null, () => {
          this.printing = false;
          this.isLoading = false;
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.printing = false;
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.tb-folgas {
  background-color: #6ece87 !important;
}
</style>
